import React, { useState } from "react";
import AlertMessage from "../../../../../partials/alertMessage";

const UpdateQuestionForm = ({ onSubmit, onCancel, currentName }) => {
	const [message, setMessage] = useState(null);
	const questionRef = React.createRef();

	setTimeout(() => {
		if (questionRef && questionRef.current)
			questionRef.current.value = currentName;
	}, 0);
	return (
		<form
			method="POST"
			onSubmit={e => {
				e.preventDefault();
				const name = questionRef.current.value;
				if (name) {
					onSubmit(name);
					setMessage(null);
					questionRef.current.value = "";
				} else {
					setMessage(`Assessment question's name is required!`);
				}
			}}
		>
			<AlertMessage message={message} failed={true} />
			<div className="form-row">
				<div className="col-12 m-b-20">
					<input
						type="text"
						id="question-name"
						name="question-name"
						ref={questionRef}
						className="form-control input-height"
						placeholder="assessment question .."
					/>
				</div>
				<div className="col">
					<button
						type="button"
						onClick={onCancel}
						className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 m-t-10 btn-circle btn-default"
					>
						Cancel<i className="material-icons text-danger">cancel</i>
					</button>
				</div>
				<div className="col">
					<button
						type="submit"
						className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 m-t-5 btn-circle btn-success"
					>
						Update Question <i className="material-icons">arrow_right_alt</i>
					</button>
				</div>
			</div>
		</form>
	);
};
export default UpdateQuestionForm;
